import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {Observable} from 'rxjs';
import * as _ from 'lodash';

export interface ICanComponentDeactivate {
    ignoreStates: string[];
    confirmExit: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable({
    providedIn: 'root',
})
export class ConfirmExitGuard  {
    canDeactivate(
        component: ICanComponentDeactivate,
        currentRoute: ActivatedRouteSnapshot,
        currentState: RouterStateSnapshot,
        nextState: RouterStateSnapshot
    ) {
        let ignoreStateMatch = false;
        //logic to allow components to still confirm exits with route exceptions
        if (component?.ignoreStates?.length > 0) {
            _.forEach(component.ignoreStates, (ignoreState: string) => {
                const urlArr = nextState.url.split('/');
                if (urlArr[urlArr.length - 1] == ignoreState) {
                    ignoreStateMatch = true;
                }
            });
        }
        //if component has ignored states, and next route matches one of them, continue routing to ignored state
        if (ignoreStateMatch) {
            return true;
        } else {
            return component?.confirmExit ? component.confirmExit() : true;
        }
    }
}
